import { AppUserRoles } from "../components/generic/SideNavComponents/menuItemsData";

// const ApiRoot = "https://localhost:7143/api";
const ApiRoot = `${process.env.REACT_APP_ROOT_API}/api` || "";
const ApiRootAdmin = `${ApiRoot}/Admin`;
const ApiRootSuperAdmin = `${ApiRoot}/SuperAdmin`;
const ApiRootUser = `${ApiRoot}/User`;
const ApiRootUserLog = `${ApiRoot}/UserLog`;
const LoginApi = `${ApiRoot}/Account/login`;
const ForgotPasswordApi = `${ApiRoot}/Account/ResetPasswordEmail`;
const ResetPasswordApi = `${ApiRoot}/Account/reset-password`;
const ChangePasswordApi = `${ApiRoot}/Account/change-password`;
const GetCountryListApi = `${ApiRoot}/Country`;
const ExportUserListApi = `${ApiRoot}/User/ExportUserList`;
const ExportFilteredUserListApi = `${ApiRoot}/User/ExportFilteredUserList`;
const ExportUserTemplateApi = `${ApiRoot}/User/ExportUserTemplate`;
const GetProfileInfo = `${ApiRoot}/Account/my-profile`;

export const AppRoutesApi = {
  Auth: {
    Login: `${LoginApi}`,
    ForgotPassword: `${ForgotPasswordApi}`,
    ResetPassword: `${ResetPasswordApi}`,
    GetProfile: `${GetProfileInfo}`,
    ChangePassword: `${ChangePasswordApi}`,
  },
  GetAllCountries: {
    GetAllCountriesList: `${GetCountryListApi}`,
  },
  SuperAdmin: {
    SuperAdminList: `${ApiRootSuperAdmin}`,
    SuperAdminCreate: `${ApiRootSuperAdmin}`,
    SuperAdminUpdate: `${ApiRootSuperAdmin}/Update`,
    SuperAdminDelete: (accountId: string) =>
      `${ApiRootSuperAdmin}/Delete/${accountId}`,
    SuperAdminDataById: (accountId: string) =>
      `${ApiRootSuperAdmin}/${accountId}`,
    SuperAdminToggleStatus: (accountId: string) =>
      `${ApiRootSuperAdmin}/ActiveDeactive/${accountId}`,
  },
  User: {
    UserList: `${ApiRootUser}`,
    UserCreate: `${ApiRootUser}`,
    UserUpdate: `${ApiRootUser}/Update`,
    UserDelete: (accountId: string) => `${ApiRootUser}/Delete/${accountId}`,
    UserDataById: (accountId: string) => `${ApiRootUser}/${accountId}`,
    UserSubscribe: (accountId: string) =>
      `${ApiRootUser}/Subscribe/${accountId}`,
    UserRenew: (accountId: string) => `${ApiRootUser}/Renew/${accountId}`,
    UserActivation: (accountId: string) =>
      `${ApiRootUser}/SentEmailForUserActivation/${accountId}`,
    ExportUserList: `${ExportUserListApi}`,
    ExportFilteredUserList: (filterType: string) => `${ExportFilteredUserListApi}?filterType=${filterType}`,
    ExportUserTemplate: `${ExportUserTemplateApi}`,
  },
  Admin: {
    AdminList: `${ApiRootAdmin}`,
    AdminCreate: `${ApiRootAdmin}`,
    AdminUpdate: `${ApiRootAdmin}/Update`,
    AdminDelete: (accountId: string) => `${ApiRootAdmin}/Delete/${accountId}`,
    AdminDataById: (accountId: string) => `${ApiRootAdmin}/${accountId}`,
    AdminToggleStatus: (accountId: string) =>
      `${ApiRootAdmin}/toggle-active-status/${accountId}`,
  },
  UserLog: {
    UserLogList: `${ApiRootUserLog}`,
    ExportUserLog: `${ApiRootUserLog}/ExportToExcel`,
  },
};

export const AppRoutesUI = {
  Root: "/",
  SuperAdmin: {
    Root: () => `${AppRoutesUI.Root}super-admin/`,
    SuperAdminList: () => `${AppRoutesUI.SuperAdmin.Root()}list/`,
    SuperAdminCreate: () => `${AppRoutesUI.SuperAdmin.Root()}create/`,
    SuperAdminEdit: () => `${AppRoutesUI.SuperAdmin.Root()}edit/:accountId`,
    SuperAdminEditById: (id: string) =>
      `${AppRoutesUI.SuperAdmin.Root()}edit/${id}`,
    SuperAdminProfile: () => `${AppRoutesUI.SuperAdmin.Root()}profile/`,
    SuperAdminChangePassword: () =>
      `${AppRoutesUI.SuperAdmin.Root()}change-password/`,
    SuperAdminProfileEdit: () =>
      `${AppRoutesUI.SuperAdmin.Root()}edit-profile/:accountId`,
    SuperAdminProfileEditById: (id: string) =>
      `${AppRoutesUI.SuperAdmin.Root()}edit-profile/${id}`,
  },
  BlackListEmail: {
    Root: () => `${AppRoutesUI.Root}black-list-email/`,
    EmailList: () => `${AppRoutesUI.BlackListEmail.Root()}list/`,
    EmailAdd: () => `${AppRoutesUI.BlackListEmail.Root()}create/`,
    EmailEdit: () => `${AppRoutesUI.BlackListEmail.Root()}edit/`,
  },
  Admins: {
    Root: () => `${AppRoutesUI.Root}admins/`,
    AdminList: () => `${AppRoutesUI.Admins.Root()}list/`,
    AdminAdd: () => `${AppRoutesUI.Admins.Root()}create/`,
    AdminEdit: () => `${AppRoutesUI.Admins.Root()}edit/:accountId`,
    AdminEditById: (id: string) => `${AppRoutesUI.Admins.Root()}edit/${id}`,
    AdminProfileView: () => `${AppRoutesUI.Admins.Root()}view/`,
    AdminChangePassword: () => `${AppRoutesUI.Admins.Root()}change-password/`,
    AdminProfileEdit: () =>
      `${AppRoutesUI.Admins.Root()}edit-profile/:accountId`,
    AdminProfileEditById: (id: string) =>
      `${AppRoutesUI.Admins.Root()}edit-profile/${id}`,
  },
  Users: {
    Root: () => `${AppRoutesUI.Root}users/`,
    UsersList: () => `${AppRoutesUI.Users.Root()}list/`,
    UsersAdd: () => `${AppRoutesUI.Users.Root()}create/`,
    UsersEdit: () => `${AppRoutesUI.Users.Root()}edit/:accountId`,
    UsersEditById: (id: string) => `${AppRoutesUI.Users.Root()}edit/${id}`,
    UsersProfileView: () => `${AppRoutesUI.Users.Root()}view/`,
    UsersProfileEdit: () => `${AppRoutesUI.Users.Root()}edit-profile/`,
  },
  UserLog: {
    Root: () => `${AppRoutesUI.Root}user-log/`,
  },

  Auth: {
    Path: () => AppRoutesUI.Root + "auth/",
    Route: "auth",
    Login: {
      Path: () => AppRoutesUI.Auth.Path() + "login/",
      Route: "login",
    },
    ForgetPassword: {
      Path: () => AppRoutesUI.Auth.Path() + "forgetPassword/",
      Route: "forgetPassword",
    },
    ResetPassword: {
      Path: () => AppRoutesUI.Auth.Path() + "ResetPassword/",
      Route: "ResetPassword",
    },
    SignUp: {
      Path: () => AppRoutesUI.Auth.Path() + "signUp/",
      Route: "signUp",
    },
  },

  NotFound: {
    Path: () => AppRoutesUI.Root + "404/",
    Route: "404",
  },
  GetRouteByRole: (role: AppUserRoles): string =>
    role === AppUserRoles.User
      ? AppRoutesUI.Users.UsersProfileView()
      : role === AppUserRoles.Admin
      ? AppRoutesUI.Admins.AdminList()
      : AppRoutesUI.SuperAdmin.SuperAdminList(),
};
